import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import * as moment from 'moment';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
	selector: 'app-terms-and-conditions',
	templateUrl: './terms-and-conditions.component.html',
	styleUrls: ['./terms-and-conditions.component.css']
})
export class TermsAndConditionsComponent implements OnInit {
	year: any = '';
	platform_name: any;
	platform_name_seprated: any;
	platform_logo: any;
	meta_logo: any;
	platform_id: any;
	project_url: any;
	faqUrl: any;

	help_center = environment.help_center;
	terms_condition = environment.terms_and_condition;
	privacy_policy = environment.privacy_policy;
	site_map = environment.siteMap_link;
	news_site_map = environment.news_site_map;

	loadAPI: Promise<any>;
	loadCssAPI: Promise<any>;
	title: string;
	merged_title: string;
	description: string;
	terms_and_condition_logo: string;
	isLoggedIn: boolean = false;
	constructor(
		private titleService: Title,
		private metaTagService: Meta,
		private route: Router,
	) {
		if (localStorage.getItem('token')) {
			this.isLoggedIn = true;
		}
		document.getElementsByTagName("HTML")[0].setAttribute("data-wf-page", "60e493eaf81420abeefd591d");

		this.year = '';
		this.platform_name = environment.platform_name;
		this.platform_name_seprated = environment.faq_name;
		this.platform_logo = environment.platform_logo;
		this.meta_logo = environment.meta_logo;
		this.platform_id = environment.platform_id;
		this.project_url = environment.project_url;
		this.faqUrl = environment.faqUrl;
		this.terms_and_condition_logo = environment.terms_and_condition_logo;

		// this.title = "Terms of Use | " + this.platform_name_seprated;
		this.title = "Terms and Condition | " + this.platform_name_seprated;
		this.merged_title = this.platform_name + ': Sports Social Media and Sports Statistics';
		// this.description = "These terms assist to characterize your connection with ItsGameTime. In general, we grant you permission to use our services provided you agree to abide by these conditions, which represent how ItsGameTime&#x27;s business operates.";
		this.description = " Access Itsgame Time Terms & Conditions for a clear View of our User Agreement..Read More to Get Better Understanding.";
		this.titleService.setTitle(this.title);
		this.metaTagService.addTag({ name: 'keywords', content: "real time sports, NFL, MLB baseball, football, soccer" });
		this.metaTagService.addTag({ name: 'description', content: this.platform_name + this.description });

		this.metaTagService.addTag({ name: 'robots', content: 'all' });

		this.metaTagService.addTag({ property: 'og:locale', content: 'en_US' });
		this.metaTagService.addTag({ property: 'og:card', content: 'summary_large_image' });
		this.metaTagService.addTag({ property: 'og:site_name', content: this.platform_name });
		this.metaTagService.addTag({ property: 'og:title', content: this.title });
		this.metaTagService.addTag({ property: 'og:description', content: this.platform_name + this.description });
		this.metaTagService.addTag({ property: 'og:url', content: this.project_url + this.route.url });
		this.metaTagService.addTag({ property: 'og:image', content: this.project_url + '' + this.terms_and_condition_logo });
		this.metaTagService.addTag({ property: 'og:image:width', content: '1200' });
		this.metaTagService.addTag({ property: 'og:image:height', content: '630' });
		this.metaTagService.addTag({ property: 'og:image:alt', content: this.platform_name + this.description });

		this.metaTagService.addTag({ name: 'twitter:card', content: 'summary_large_image' });
		this.metaTagService.addTag({ name: 'twitter:site_name', content: this.platform_name });
		this.metaTagService.addTag({ name: 'twitter:title', content: this.title });
		this.metaTagService.addTag({ name: 'twitter:description', content: this.platform_name + this.description });
		this.metaTagService.addTag({ name: 'twitter:url', content: this.project_url + this.route.url });
		this.metaTagService.addTag({ name: 'twitter:image', content: this.project_url + '' + this.terms_and_condition_logo });
		this.metaTagService.addTag({ name: 'twitter:image:width', content: '800' });
		this.metaTagService.addTag({ name: 'twitter:image:height', content: '480' });
		this.metaTagService.addTag({ name: 'twitter:image:alt', content: this.platform_name + this.description });

		this.removejscssfile("its-game-time.js", "js");
		this.removejscssfile("normalize.css", "css");
		this.removejscssfile("components.css", "css");
		this.removejscssfile("its-game-time.css", "css");



		this.loadCssAPI = new Promise((resolve) => {
			this.addandLoadCss();
			resolve(true);
		});
	}

	logout() {
		localStorage.clear();
		sessionStorage.removeItem('fullcomponent');
		this.route.navigate(['/login']);
	}

	removejscssfile(filename, filetype) {
		let targetelement = (filetype == "js") ? "script" : (filetype == "css") ? "link" : "none" //determine element type to create nodelist from
		let targetattr = (filetype == "js") ? "src" : (filetype == "css") ? "href" : "none" //determine corresponding attribute to test for
		let allsuspects = document.getElementsByTagName(targetelement)
		for (let i = allsuspects.length; i >= 0; i--) { //search backwards within nodelist for matching elements to remove
			if (allsuspects[i] && allsuspects[i].getAttribute(targetattr) != null && allsuspects[i].getAttribute(targetattr).indexOf(filename) != -1)
				allsuspects[i].parentNode.removeChild(allsuspects[i]) //remove element by calling parentNode.removeChild()
		}
	}

	ngOnInit(): void {
		this.year = moment().year();
	}

	public loadScript() {
		let isFound = false;
		let scripts = document.getElementsByTagName("script")
		for (let i = 0; i < scripts.length; ++i) {
			if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('class') && scripts[i].getAttribute('class').includes("itsgametimeJs")) {
				isFound = true;
			}
		}

		if (!isFound) {
			let dynamicScripts = [

				"../../assets/landing-js/its-game-time.js",
			];

			for (let i = 0; i < dynamicScripts.length; i++) {
				let node = document.createElement('script');
				node.src = dynamicScripts[i];
				node.type = 'text/javascript';
				node.async = false;
				node.charset = 'utf-8';
				document.getElementsByTagName('body')[0].appendChild(node);
			}

		}

	}

	public addandLoadCss() {
		let isFoundCss = false;
		let linkArray = document.getElementsByTagName("link");
		for (let i = 0; i < linkArray.length; i++) {
			if (linkArray[i].getAttribute('href') != null && linkArray[i].getAttribute('id') && linkArray[i].getAttribute('id').includes("itsGameTimeCss")) {
				isFoundCss = true;
			}
		}

		if (!isFoundCss) {
			let dynamicCss = [

				"../../assets/landing-css/normalize.css",
				"../../assets/landing-css/components.css",
				"../../assets/landing-css/its-game-time.css",
			];

			for (let i = 0; i < dynamicCss.length; i++) {
				let link = document.createElement('link');
				link.rel = "stylesheet";
				link.type = 'text/css';
				link.id = "itsGameTimeCss" + i;
				link.href = dynamicCss[i];
				document.head.appendChild(link);
			}
		}
		this.loadScript();
	}

	ngAfterViewInit() {
		scrollTo(0, 20);
		setTimeout(() => {
			scrollTo(0, 0);
		}, 100);
	}

	ngOnDestroy() {
		this.removejscssfile("its-game-time.js", "js");
		this.removejscssfile("normalize.css", "css");
		this.removejscssfile("components.css", "css");
		this.removejscssfile("its-game-time.css", "css");
	}
}
